import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root'
})
export class MastrService {

  constructor(private apiService: ApiBaseService) { }

  async getMastrData(payload: any): Promise<any> {
    return this.apiService.httpRequest('MastrService/GetMastrData', payload, true, false);
  }

  async saveMastrData(payload: any): Promise<any> {
    return this.apiService.httpRequest('MastrService/SaveMastrData', payload, true, false);
  }

  async deleteMastrData(payload: any): Promise<any> {
    return this.apiService.httpRequest('MastrService/DeleteMastrData', payload, true, false);
  }

  async setMastrTaskStatus(payload: any): Promise<any> {
    return this.apiService.httpRequest('MastrService/SetMastrTaskStatus', payload, true, false);
  }

  async getMastrTaskStatus(payload: any): Promise<any> {
    return this.apiService.httpRequest('MastrService/GetMastrTaskStatus', payload, true, false);
  }

  async uploadConformityDocument(formData: FormData): Promise<any> {
    return this.apiService.httpRequestForm('MastrService/UploadConformityDocument', formData, true, true);
  }

  async deleteConformityDocument(payload: any): Promise<any> {
    return this.apiService.httpRequest('MastrService/DeleteConformityDocument', payload, true, true);
  }
}
